import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Lit une seule fois le marqueur de clôture posé par la page Live, puis vide l'entrée d'historique.
 *  Sans ce nettoyage, un retour arrière sur la même entrée rejouerait la sollicitation hors contexte. */
export function useLiveCloseNavigationFlag(): boolean {
  const location = useLocation();
  const navigate = useNavigate();
  const navigationState = location.state as { fromLiveClose?: boolean } | null;
  const hasJustClosedLive = navigationState?.fromLiveClose === true;

  const [isReturningFromLive] = useState(hasJustClosedLive);

  useEffect(() => {
    if (!hasJustClosedLive) return;
    navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
  }, [navigate, hasJustClosedLive, location.pathname, location.search]);

  return isReturningFromLive;
}
